<div class="seedEfulfillment">
  <div class="OrderVarietyDetail">
    <div class="row dialogHeader">
      <h2>Add Variety</h2>
    </div>
    <!--Product Detail section-->
    <div class="form-sec">
  
      <div class="row mt-2 margin-b20">
        <div class="col-md-11 product-filter-outer p-0">
          <div class="product-filter-outer">
            <div class="product-filter col-md-12">
              <div class="search-category">
                <div class="brand-dropdown default-select agent-crop-select">
                  <ng-select [items]="searchTypeList"
                             name="ddlProductSearch"
                             [(ngModel)]="productSearchFilter"
                             [virtualScroll]="true"
                             [closeOnSelect]="true"
                             [selectOnTab]="true"
                             [clearable]="false"
                             bindLabel="name"
                             bindValue="value"
                             [searchable]="false"
                             (change)="keepFilter()"
                             placeholder="Select Category">
                  </ng-select>
                </div>
              </div>
              <div class="search-box marketBrandSelect">
                <div class="row margin-0">
                  <div class="default-select select-container">
                    <div *ngIf="productSearchFilter === 'Variety'">
                      <div class="searchInputBox">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input class="custom-select-grower" [(ngModel)]="productFilters.Variety" placeholder="Search...">
                        </div>
                      </div>
                    </div>
                    <div class="agent-crop-select">
                      <ng-select #productSearch name="ddlproductSearch" *ngIf="productSearchFilter === 'marketingBrand'"
                                 [items]="marketingMasterList"
                                 placeholder="Search..."
                                 class="custom-select-grower"
                                 [multiple]="true"
                                 [hideSelected]="true"
                                 [(ngModel)]="productFilters.MarketingBrandList"
                                 [virtualScroll]="true"
                                 bindLabel="value"
                                 bindValue="id"
                                 [closeOnSelect]="true"
                                 [searchFn]="filterSearchFn"
                                 (remove)="getFilterData()"
                                 (clear)="getFilterData()"
                                 (change)="keepFilter()">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name">
                                  {{item.value}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
  
                  </div>
                </div>
              </div>
            </div>
            <div class="row chips-sec" *ngIf="filterValueList != '' ">
              <div class="col-sm-9 col-md-10 selected-chip">
                <mat-chip-set>
                  <mat-chip selected *ngFor="let filterValue of filterValueList">
                    {{filterValue}}
                    <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                      <i class="fas fa-times text-right"></i>
                    </a>
                  </mat-chip>
                </mat-chip-set>
              </div>
              <div class="col-sm-3 col-md-2 text-right">
                <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1">
          <button mat-raised-button (click)="getFilterData()" class="btns">Search</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 productTableOuter p-0">
        <div class="tableContainer">
        <table mat-table [dataSource]="associateOrderSource" multiTemplateDataRows class="matTables productTable">
            <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
              <div *ngIf="column=='marketingBrand'"><th mat-header-cell *matHeaderCellDef class="text-center">Marketing Brand</th>
        </div>
        <div *ngIf="column=='variety'"><th mat-header-cell *matHeaderCellDef class="text-center">Variety</th></div>
        <div *ngIf="column=='availableQty'"><th mat-header-cell *matHeaderCellDef class="convFactor text-center">Available Qty</th></div>
        <div *ngIf="column=='orderQty'"><th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity">Order Qty</th></div>
        <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="text-center">UOM</th> </div>
        <div *ngIf="column=='preferredPackagingSize'"><th mat-header-cell *matHeaderCellDef class="total-units text-center">Preferred Pkg Size</th></div>
  
        <td mat-cell *matCellDef="let element">
  
          <div *ngIf="column=='marketingBrand'" class="text-center">
            <div>
              <p>{{element.marketingBrand}}</p>
            </div>
          </div>
          <div *ngIf="column=='variety'" class="text-center">
            <div>
              <p>{{element.variety}}</p>
            </div>
          </div>
  
          <div *ngIf="column=='availableQty'" class="available-block text-center">
            <div>
              <span> {{element.availableQty | number}}</span>
            </div>
          </div>
  
          <div *ngIf="column=='orderQty'" class="text-center">
            <div>
              <button (click)="AssociateOrderUnitChange('decrease',element)" class="plus-minus-btn minusBtn"> - </button>
              <input type="text" class="geu-txt padding-t2" [(ngModel)]="element.orderQty" (focusout)="validateLineItem(element, 'orderQty')" (keyup)="quantityTextChange(element)" maxlength="15" appNumbersOnly />
              <button (click)="AssociateOrderUnitChange('increase',element)" class="plus-minus-btn plusBtn"> + </button>
            </div>
          </div>
          <div *ngIf="column=='uom'" class="text-center">
            <div>
              <span> {{element.uom}}</span>
            </div>
          </div>
          <div *ngIf="column=='preferredPackagingSize'" class="text-center">
            <div>
              <input type="text" class="geu-txt padding-t2 input-width" [(ngModel)]="element.preferredPackagingSize" maxlength="50" />
            </div>
          </div>
        </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div class="inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
              <div class="row">
                <div class="col-md-9">
                  <ol class="error-list">
                    <li *ngFor="let err of element.lineErrors.errors">
                      {{err.error}}
                  </ol>
                </div>
                <!--<div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                  <span>
                    Revert to Previous.
                    <i class="icon-ico-Reply"></i>
                  </span>
                </div>-->
              </div>
            </div>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
        <tr mat-row
            *matRowDef="let element; columns: ['expandedDetail']; when: isExpansionRow"
            class="example-detail-row">
        </tr>
        </table>
        <div *ngIf="associateOrderSource == undefined || (associateOrderSource && associateOrderSource.data.length == 0)" class="noDataMsg">
          <p class="padding-b47">No eligible varieties available for this order.</p>
        </div>
      </div>
    </div>
  </div>
  </div>
  
</div>


<div class="row add-order-sec margin-l0 margin-r0">
  <div class="col-md-6 xs-pl-0 xs-pr-0">
    <button data-testid="ddl-add-cpp-product-model" mat-raised-button class="btns xs-button xs-full-width"  [disabled]="isPlaceOrderDisable" color="primary" (click)="addHybridVariety()"  >Add Variety</button>&nbsp;&nbsp;
    <button data-testid="ddl-add-cpp-product-model" mat-raised-button class="btns xs-button xs-full-width" color="primary"  (click)="cancelClick()" >Cancel</button>
  </div>
</div>
